import React, { useState } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import api from '../services/api';
import styles from './Page.module.css';

// Lista de consulta — o cadastro completo é feito em Cad. Fornecedores.
// Pedido 2026-09-24: mesma ideia da tela "Clientes" (lista simples), com um
// extra — sinaliza quem está com o cadastro incompleto (sem razão social/
// endereço) e deixa completar na hora com a mesma lupinha 🔍 que consulta o
// CNPJ (BrasilAPI/Receita Federal) já usada no Cad. Fornecedores.
export default function ListaFornecedores() {
  const [busca, setBusca] = useState('');
  const [atualizandoId, setAtualizandoId] = useState(null);
  const queryClient = useQueryClient();

  const { data: fornecedores = [], isLoading } = useQuery({
    queryKey: ['fornecedores-lista', busca],
    queryFn: () => api.get('/fornecedores', { params: { busca } }).then((r) => r.data),
  });

  const endereco = (f) => {
    const partes = [f.logradouro, f.numero].filter(Boolean);
    return partes.length ? partes.join(', ') : '—';
  };

  const atualizarViaCnpj = async (f) => {
    const cnpj = (f.cpf_cnpj || '').replace(/\D/g, '');
    if (cnpj.length !== 14) return; // lupinha só existe pra CNPJ (botão nem aparece pra CPF)
    setAtualizandoId(f.id);
    try {
      const [{ data: atual }, { data: dadosCnpj }] = await Promise.all([
        api.get(`/fornecedores/${f.id}`),
        api.get(`/fornecedores/buscar-cnpj/${cnpj}`),
      ]);
      // Só preenche o que estiver vazio — não sobrescreve nada que já foi
      // digitado/revisado na mão.
      const n = (v) => (v === '' || v == null ? null : v);
      const payload = {
        nome_fantasia: atual.nome_fantasia || dadosCnpj.nome_fantasia,
        razao_social:  atual.razao_social  || dadosCnpj.razao_social,
        cpf_cnpj:      atual.cpf_cnpj,
        tipo_contribuinte: atual.tipo_contribuinte,
        ie:            atual.ie || dadosCnpj.ie,
        suframa:       atual.suframa,
        cep:           atual.cep        || dadosCnpj.cep,
        logradouro:    atual.logradouro || dadosCnpj.logradouro,
        numero:        atual.numero     || dadosCnpj.numero,
        complemento:   atual.complemento || dadosCnpj.complemento,
        bairro:        atual.bairro     || dadosCnpj.bairro,
        cidade:        atual.cidade     || dadosCnpj.cidade,
        uf:            atual.uf         || dadosCnpj.uf,
        site:          atual.site,
        email:         atual.email      || dadosCnpj.email,
        contato:       atual.contato,
        fone:          atual.fone       || dadosCnpj.fone,
        observacoes:   atual.observacoes,
        inativo:       atual.inativo,
        plano_conta_codigo: atual.plano_conta_codigo,
      };
      Object.keys(payload).forEach(k => { payload[k] = n(payload[k]); });
      await api.put(`/fornecedores/${f.id}`, payload);
      queryClient.invalidateQueries({ queryKey: ['fornecedores-lista'] });
    } catch (err) {
      alert(err.response?.data?.erro || 'Erro ao consultar/atualizar o CNPJ.');
    } finally {
      setAtualizandoId(null);
    }
  };

  return (
    <div>
      <div className={styles.topbar}>
        <h2 className={styles.titulo}>Fornecedores</h2>
        <div className={styles.acoes}>
          <input className={styles.busca} placeholder="Buscar fornecedor..." value={busca} onChange={(e) => setBusca(e.target.value)} />
        </div>
      </div>

      {isLoading ? <p>Carregando...</p> : (
        <div className={styles.tabela}>
          <table>
            <thead>
              <tr>
                <th>Cód.</th>
                <th>Nome Fantasia</th>
                <th>Razão Social</th>
                <th>CNPJ/CPF</th>
                <th>Telefone</th>
                <th>Endereço</th>
                <th>Bairro</th>
                <th>Cidade</th>
                <th>UF</th>
                <th>CEP</th>
                <th>Cadastro</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {fornecedores.map((f) => {
                const ehCnpj = (f.cpf_cnpj || '').replace(/\D/g, '').length === 14;
                return (
                  <tr key={f.id}>
                    <td>{f.codigo}</td>
                    <td><strong>{f.nome_fantasia || '—'}</strong></td>
                    <td>{f.razao_social || '—'}</td>
                    <td>{f.cpf_cnpj || '—'}</td>
                    <td>{f.fone || '—'}</td>
                    <td>{endereco(f)}</td>
                    <td>{f.bairro || '—'}</td>
                    <td>{f.cidade || '—'}</td>
                    <td>{f.uf || '—'}</td>
                    <td>{f.cep || '—'}</td>
                    <td>
                      {f.cadastro_incompleto
                        ? <span className={`${styles.badge} ${styles.badgePendente}`}>⚠ Incompleto</span>
                        : <span className={`${styles.badge} ${styles.badgeAtivo}`}>✔ Completo</span>}
                    </td>
                    <td>
                      {f.cadastro_incompleto && ehCnpj && (
                        <button
                          className={styles.btnSecundario}
                          disabled={atualizandoId === f.id}
                          title="Consultar CNPJ e completar automaticamente"
                          onClick={() => atualizarViaCnpj(f)}
                        >
                          {atualizandoId === f.id ? '⏳' : '🔍 Completar'}
                        </button>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
